import { render, staticRenderFns } from "./detalle-entrada.vue?vue&type=template&id=a1f4b2dc"
import script from "./detalle-entrada.vue?vue&type=script&lang=js"
export * from "./detalle-entrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports